// extracted by mini-css-extract-plugin
export default {"container":"Link_container__UVy+R","title":"Link_title__HUk2t"};